var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94693 13.9689L1.74707 7.83683C1.90156 7.56351 2.42445 6.8885 3.28009 6.37512C4.13572 5.86174 5.20527 6.20875 5.63309 6.44642C6.82147 7.32583 9.32659 9.17733 9.83997 9.54811C10.3534 9.91888 10.6481 10.5107 10.7313 10.7603C11.0735 12.2434 10.351 13.5173 9.94693 13.9689Z",
    fill: "#FB7C51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91093 9.62173L5.98926 6.73395L10.624 1.42188L13.69 3.73923L9.91093 9.62173Z",
    fill: "#FB7C51"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.91113,
    y: 0.939453,
    width: 0.91492,
    height: 5.68719,
    rx: 0.213909,
    transform: "rotate(-52.9215 9.91113 0.939453)",
    fill: "#FB7C51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98946 11.0104L5.16947 10.4043L0.427819 16.7146L0 18.105L1.2478 17.3207L5.98946 11.0104Z",
    fill: "#FB7C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pinIcon.b2ce4299e9f3190985869d7b1bd2e9ba.svg";
export { ForwardRef as ReactComponent };